import { get } from 'svelte/store';
import Pusher from 'pusher-js'; // Standard static import
import { notificationStore } from './notificationStore.js';
import { totalRewards } from './rewardsStore.js';
import { selectedCountry } from './countryStore.js';
import { getApiUrl } from './api.js';
import { currentLang } from './i18nStore.js';

let pusherInstance = null;
let isInitializing = false;

export async function initializePusher() {
  if (pusherInstance || isInitializing) {
    return;
  }
  isInitializing = true;

  try {
    //const PUSHER_KEY = import.meta.env.VITE_PUSHER_KEY;
    //const PUSHER_CLUSTER = import.meta.env.VITE_PUSHER_CLUSTER;
    const PUSHER_KEY = "__VITE_PUSHER_KEY__";
    if (PUSHER_KEY.startsWith('__VITE_')) {
      console.warn("Failed to retrieve PUSHER_KEY.")
    }
    const PUSHER_CLUSTER = "__VITE_PUSHER_CLUSTER__";
    if (PUSHER_CLUSTER.startsWith('__VITE_')) {
      console.warn("Failed to retrieve PUSHER_CLUSTER.")
    }

    if (!PUSHER_KEY || !PUSHER_CLUSTER) {
        console.warn("Pusher keys not found.");
        return;
    }

    console.log("Initializing Pusher...");

    // --- THE FIX: Lowercase Alias ---
    const pusherLib = Pusher;
    pusherInstance = new pusherLib(PUSHER_KEY, {
      cluster: PUSHER_CLUSTER
    });

    const channel = pusherInstance.subscribe('global-notifications');
    
    channel.bind('new-transaction', function(data) {
      console.log("Pusher event:", data);
      
      const lang = get(currentLang);
      let message = data.message;
      if (data.userName && data.rewardAmount && data.promotionName) {
        if (lang === 'zh-HK') {
          message = `${data.userName} 剛剛用「${data.promotionName}」推廣節省了 $${data.rewardAmount}！`;
        } else if (lang === 'ja') {
          message = `${data.userName}さんが「${data.promotionName}」プロモーションで$${data.rewardAmount}節約しました！`;
        } else {
          message = `${data.userName} just saved $${data.rewardAmount} with the '${data.promotionName}' promotion!`;
        }
      }
      
      notificationStore.set(message);
    });

    channel.bind('update-total-rewards', async function(data) {
      const currentCountry = get(selectedCountry);
      if (data.countryCode === currentCountry) {
          try {
            const res = await fetch(getApiUrl(`/rewards/total?countryCode=${currentCountry}`));
            const result = await res.json();
            totalRewards.set(result.total || 0);
          } catch(e) {
            console.error("Failed to fetch fresh total:", e);
          }
      }
    });

    channel.bind('admin-broadcast', function(data) {
      console.log("Pusher [admin-broadcast]:", data);
      
      // Ensure we extract the string text correctly. 
      // If data.message is somehow missing or complex, fallback safely.
      let msgText = "System Message";
      
      if (typeof data === 'string') {
          msgText = data;
      } else if (data && data.message) {
          msgText = typeof data.message === 'string' ? data.message : JSON.stringify(data.message);
      }
      
      notificationStore.set({ 
          message: `📢 ADMIN ALERT: ${msgText}`,
          type: 'admin' // Optional: could use this to style it differently
      });
    });

  } catch (e) {
    console.error("Error during Pusher initialization:", e);
  } finally {
      isInitializing = false;
  }
}